<template>
  <v-form ref="form" v-model="valid" validate-on="submit lazy">
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="chitData.wo_number"
          label="W/O #"
          variant="outlined"
          hide-details="auto"
          density="compact"
          @update:model-value="clearErrors()"
          :error-messages="error && (error.fieldErrors['wo_number'] as string[])"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="chitData.unit_number"
          label="SYS #/Unit"
          variant="outlined"
          hide-details="auto"
          density="compact"
          @update:model-value="clearErrors()"
          :error-messages="error && (error.fieldErrors['unit_number'] as string[])"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="chitData.tech_name"
          label="Tech Name"
          variant="outlined"
          hide-details="auto"
          density="compact"
          @update:model-value="clearErrors()"
          :error-messages="error && (error.fieldErrors['tech_name'] as string[])"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <PhoneField
          v-model="chitData.tech_phone_number"
          label="Tech Phone #"
          variant="outlined"
          hide-details="auto"
          density="compact"
          @update:model-value="clearErrors()"
          :error-messages="error && (error.fieldErrors['phone'] as string[])"
        ></PhoneField>
      </v-col>
      <v-col cols="12" v-if="!isEdit">
        <v-textarea
          v-model="chitData.comments"
          label="Comments"
          variant="outlined"
          hide-details="auto"
          density="compact"
          @update:model-value="clearErrors()"
          :error-messages="error && (error.fieldErrors['comments'] as string[])"
        ></v-textarea>
      </v-col>
    </v-row>
  </v-form>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import type { ISystemError } from '@/models/error'
import type { VForm } from 'vuetify/components'
import { type IChitDetailData } from '@/models/chit'

import PhoneField from '../common/PhoneField.vue'

interface Props {
  isEdit: boolean
  error?: ISystemError | null
}

defineProps<Props>()

const chitData = defineModel<IChitDetailData>({ required: true })

const form = ref<VForm>()
const valid = ref(false)

async function validateForm() {
  clearErrors()
  const { valid } = await form.value!.validate()
  return valid
}

function resetFormValidation() {
  form.value?.resetValidation()
}

function clearErrors() {
  resetFormValidation()
}

defineExpose({
  validateForm,
  clearErrors
})
</script>
